import { useContext } from 'react';
import useHttp from './useHttp';
import AuthContext from '../context/authContext';

const useEntertainment = () => {
  const authCtx = useContext(AuthContext);
  const { isLoading, error, sendRequest } = useHttp();

  const getEntertainments = async (light = false) => {
    return new Promise(async (resolve, reject) => {
      try {
        const responseData = await sendRequest({
          url: `/api/v1/entertainment`,
          method: 'GET',
          headers: authCtx.getAuthHeaders(),
          params: {
            light: light,
          },
        });

        resolve(responseData);
      } catch (error) {
        reject(error);
      }
    });
  };

  const getAllEntertainmentsByBranch = async branchId => {
    return new Promise(async (resolve, reject) => {
      try {
        const responseData = await sendRequest({
          url: `/api/v1/entertainment/by/branch/${branchId}`,
          method: 'GET',
          headers: authCtx.getAuthHeaders(),
        });

        resolve(responseData);
      } catch (error) {
        reject(error);
      }
    });
  };

  const getEntertainmentById = async entertainmentId => {
    return new Promise(async (resolve, reject) => {
      try {
        const responseData = await sendRequest({
          url: `/api/v1/entertainment/${entertainmentId}`,
          method: 'GET',
          headers: authCtx.getAuthHeaders(),
        });

        resolve(responseData);
      } catch (error) {
        reject(error);
      }
    });
  };

  const getProductsByEntertainmentId = async entertainmentId => {
    return new Promise(async (resolve, reject) => {
      try {
        const responseData = await sendRequest({
          url: `/api/v1/entertainment/${entertainmentId}/products`,
          method: 'GET',
          headers: authCtx.getAuthHeaders(),
        });

        resolve(responseData);
      } catch (error) {
        reject(error);
      }
    });
  };

  const setEmergencyPrintMode = async ({ entertainmentId, emergencyPrintMode }) => {
    try {
      const responseData = await sendRequest(
        {
          url: `/api/v1/entertainment/${entertainmentId}/emergencyPrintMode`,
          method: 'PATCH',
          headers: authCtx.getAuthHeaders(),
          body: { emergencyPrintMode },
        },
        'Fehler beim Speichern des Notfallmodus'
      );
      return responseData;
    } catch (error) {
      throw error;
    }
  };

  return {
    isLoading,
    error,
    getEntertainments,
    getAllEntertainmentsByBranch,
    getEntertainmentById,
    getProductsByEntertainmentId,
    setEmergencyPrintMode,
  };
};

export default useEntertainment;
